import React from "react";

import { AiFillMinusCircle } from "@react-icons/all-files/ai/AiFillMinusCircle";
import { BsPlusCircleFill } from "@react-icons/all-files/bs/BsPlusCircleFill";

import { pluralise } from "@Utils/common";
import { classNames } from "repoV2/utils/common/render/classNames";
import useFlexibleAppointmentSelector from "./useFlexibleAppointmentSelector";
import styles from "../Merchandise/merchandise.module.scss";

const FlexibleQuantitySelector = () => {
    const {
        currency,
        price,
        quantity,
        totalSlots,
        disableDecreaseClick,
        disableIncreaseClick,
        hasBatchedSessions,
        handleIncreaseQty,
        handleDecreaseQty,
    } = useFlexibleAppointmentSelector();

    return (
        <div className={styles.root}>
            <div>
                {hasBatchedSessions ? (
                    <div className={styles.priceDesc}>
                        <span className={styles.unitText}>
                            Price for {totalSlots}{" "}
                            {pluralise("slot", totalSlots || 1)}
                        </span>
                        <span className="flexGrow" />
                        <span className={styles.price}>
                            {price ? currency : null}
                            &nbsp;
                            {price * (totalSlots || 1)}
                        </span>
                    </div>
                ) : (
                    <>
                        <div className={styles.priceDesc}>
                            <span className={styles.unitText}>
                                Price per slot
                            </span>
                            <span className="flexGrow" />
                            <span className={styles.price}>
                                {price ? currency : null}
                                &nbsp;
                                {price}
                            </span>
                        </div>
                        <div className={styles.qtyContainer}>
                            <div
                                role="button"
                                onKeyDown={() => null}
                                tabIndex={-1}
                                className={classNames(
                                    styles.reduceQty,
                                    disableDecreaseClick && styles.disabled
                                )}
                                id="merchandise-qtyUp"
                                onClick={handleDecreaseQty()}
                            >
                                <AiFillMinusCircle />
                            </div>
                            <div className={styles.quantity}>
                                {quantity} {pluralise("slot", quantity)}
                            </div>
                            <div
                                className={classNames(
                                    styles.increaseQty,
                                    disableIncreaseClick && styles.disabled
                                )}
                                id="merchandise-qtyDown"
                                role="button"
                                onKeyDown={() => null}
                                tabIndex={-1}
                                onClick={handleIncreaseQty()}
                            >
                                <BsPlusCircleFill />
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default FlexibleQuantitySelector;
